/**
 * Main store exports for Zustand state management system
 * Central export point for all store functionality
 */

// Type exports
export type * from './types'

// Middleware exports
export * from './middleware'

// Store slice exports
export * from './slices'

// Hook exports
export * from './hooks'

// Store instances for direct access (use sparingly)
export {
  authStore,
  uiStore,
  navigationStore,
  userStore,
  applicationStore,
  cacheStore,
  workspaceStore
} from './slices'

// Main combined store hook
export { useStore, useStoreSelector, useStoreActions, useStoreState } from './hooks/use-store'

// Initialization function
import { initializeApplication } from './slices/application-slice'
import { authStore, uiStore } from './slices'
import { getAccessToken } from '@/utils/auth-storage'

/**
 * Initialize all stores with default values
 * Call this once during app startup
 */
export const initializeStores = async () => {
  // Initialize application store
  initializeApplication()
  
  // Apply theme immediately on initialization
  const uiState = uiStore.getState()
  uiState.setTheme(uiState.theme)
  
  // Attempt session restoration if we have a valid auth token
  try {
    const accessToken = getAccessToken()
    if (accessToken) {
      const authState = authStore.getState()
      await authState.restoreSession()
    }
  } catch (error) {
    console.warn('App initialization - Session restoration failed:', error)
    // Don't throw error, just log it and continue
  }
}